import { NgFor } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'admin-search-client',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatSelectModule,
    NgFor,
    MatInputModule,
    MatCheckboxModule,
    MatButtonModule,
    FormsModule,
  ],
  templateUrl: './search-clients.component.html',
  styleUrls: ['./search-clients.component.scss'],
})
export class SearchClientComponent {
  clients = ['Cofaris', 'Unofi', 'Office Dupont'];
  modesDePaiement = ['SEPA', 'Virement', 'Carte Bancaire'];
  renouvellementAutoValues = ['Oui', 'Non', 'Incounu'];
}
